const toTimestamp = (timeInSeconds, ignoreHours)=>{
    let minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.ceil(timeInSeconds - 60 * minutes);
    if (!ignoreHours && minutes >= 60) {
        const hours = Math.floor(minutes / 60);
        minutes = Math.ceil(minutes - 60 * hours);
        return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`;
    }
    return `${ignoreHours && minutes >= 10 ? minutes : `0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`;
};
const date_toTimestamp = toTimestamp;
export default date_toTimestamp;
